import $ from 'jquery';
import Vivus from 'vivus'

export function inlineSVG( svgImgSelector = '.svg' ) {
    
    var svgCount = $('img' + svgImgSelector ).length;

    // Push SVG to inline so we can edit them
    $('img' + svgImgSelector ).each(function(i) {
        let $this = $(this)
        $.get($this.attr('src'), function(data) {
            let $svg = $(data).find('svg').addClass('inline-svg').removeAttr('xmlns:a')
            $this.replaceWith($svg)
        }, 'xml')

        if ( ( svgCount - 1 ) == i ) {
            setTimeout(
                function() {
                    drawIcons();
                },
                150
            );
        }
    })

    function drawIcons() {

        const $highlights_icon = $('.highlights__icon svg, .inline-svg');

        for ( let i = 0; i <= $highlights_icon.length - 1; i++ ) {
            
            let icon = $highlights_icon.get(i),
                _id = `highlights-icon-${i}`;
            
            icon.classList.remove('inline-svg');

            icon.id = _id;

            new Vivus( _id, {
                type: 'delayed',
                duration: 150,
                animTimingFunction: Vivus.EASE_OUT
            } );

        }

    }

}